export default "__VITE_ASSET__CLBJq2qH__"